import React from 'react';
import { Link } from 'react-router-dom';
import SeoMeta from '../components/SeoMeta';
import FadeIn from '../components/FadeIn';

export default function ThankYouPage() {
  return (
    <main className="bg-brand-vintage min-h-screen pt-32 pb-24 flex items-center justify-center relative overflow-hidden">
      <SeoMeta
        title="Thank You | Padua Weddings"
        description="Thank you for inquiring with Padua Weddings. We look forward to connecting with you soon."
        noindex
      />
      <div className="absolute top-0 right-0 w-1/3 h-full bg-brand-stone/5 pointer-events-none" />
      <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
        <FadeIn>
          <span className="text-brand-bronze uppercase tracking-[0.4em] text-[10px] font-bold mb-6 block">
            Inquiry Received
          </span>
          <h1 className="font-serif text-4xl md:text-6xl text-brand-charcoal mb-8 font-light leading-tight">
            Thank You for <br className="hidden md:block" />
            <span className="italic text-brand-olive">Reaching Out</span>
          </h1>
          <div className="w-16 h-[1px] bg-brand-stone mx-auto mb-10" />
          <p className="font-sans text-brand-charcoal/80 text-lg leading-relaxed font-light mb-12 max-w-xl mx-auto">
            We have received your details. Our team is currently reviewing our calendar and will reach out to you within 24-48 hours to discuss availability, pricing, and next steps for a private tour.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <Link to="/weddings/gallery" className="w-full sm:w-auto inline-block bg-brand-olive text-brand-vintage px-12 py-4.5 text-[10px] uppercase tracking-[0.25em] hover:bg-brand-charcoal transition-all font-bold shadow-xl border border-transparent">
              Explore the Gallery
            </Link>
            <Link to="/weddings/faq" className="w-full sm:w-auto inline-block border border-brand-charcoal text-brand-charcoal px-12 py-4.5 text-[10px] uppercase tracking-[0.25em] hover:bg-brand-aged transition-all font-bold">
              Read the FAQs
            </Link>
          </div>
        </FadeIn>
      </div>
    </main>
  );
}